<template>
  <section>
    <spec class="title">{{ file.template }}</spec>
  </section>
</template>

<script>
import Spec from './Spec.vue'

export default {
  props: ['file'],
  components: { Spec }
}
</script>

<style lang="scss" scoped>
.title {
  font-weight: 600;
}
</style>
